import { PersonWithDuplicatesQuery } from './duplicate-resolver.generated';
import { MergeCandidate } from './types';

type PersonDuplicateTypeBase = PersonWithDuplicatesQuery['personWithDuplicates'];

export function extractCandidates(person: PersonDuplicateTypeBase | undefined) {
  if (!person) return [];

  const candidates: MergeCandidate[] = [person as MergeCandidate];

  (person as any).duplicates?.forEach((item: any) => {
    const other = person.id !== item.person1.id ? item.person1 : item.person2;
    candidates.push(other);
  });

  return candidates;
}
